// extracted by mini-css-extract-plugin
export default {"inputsContainer":"OptionsInputSection_inputsContainer__zadTr","labelAndInputRow":"OptionsInputSection_labelAndInputRow__3G9-6"};